import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { RealizarConsultaService } from 'src/app/services/http/realizar-consulta.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Consulta } from 'src/app/models/consulta';

@Component({
  selector: 'app-form-consulta-lote',
  templateUrl: './form-consulta-lote.component.html',
  styleUrls: ['./form-consulta-lote.component.scss']
})
export class FormConsultaLoteComponent implements OnInit {

  listaConsultas:Consulta[] = [];

  form = new FormGroup({
    tipoConsulta: new FormControl('', [Validators.required]),
    arquivo: new FormControl('', [Validators.required])
  });

  constructor(private router: Router, private consultaService: ConsultaService, private realizarConsultaService: RealizarConsultaService, private msgService: ModalMsgService) {
    this.consultaService.listaConsulta().then(r => this.listaConsultas = r);
  }

  ngOnInit() {
  }

  setFile() {
  }

  deleteFile() {
    this.form.controls.arquivo.patchValue('');
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.controls.arquivo.setValue(file);
    }
  }

  enviar() {
    if (this.form.invalid) {
      for (const key in this.form.controls) {
        this.form.controls[key].markAsTouched();
      }
      return;
    }
    let form = this.form.value;
    this.realizarConsultaService.enviarConsultaLote(form.tipoConsulta, form.arquivo).then(result => {
      if(result.erro) {
        this.msgService.openDialog('Erro ao enviar arquivo', '', 'danger');
      } else {
        this.router.navigate(['consulta','lote','resultado', result]);
      }
    });
  }

}
